import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import {
  Navbar,
  Nav,
  NavItem,
  Grid,
  Row,
  Col,
  Panel,
  Button
} from 'react-bootstrap';
import { CustomNav } from '../Components/CustomNav';
import { TeamManagement } from '../Pages/TeamManagement';
import { CapManagement } from '../Pages/CapManagement';
import { Trade } from '../Pages/Trade';
import { Video } from '../Pages/Video';
import { Dashboard } from '../Pages/Dashboard';
import { Contract } from '../Pages/Contract';
import { AddUser } from '../Pages/AddUser';
import { Research } from '../Pages/Research';
import { Wizard } from '../Pages/Wizard';
import { Draft } from '../Pages/Draft';
import { Account } from '../Pages/Account';
import { BigDepthChart } from '../Pages/BigDepthChart';
import { Managers } from '../Pages/Managers';
import { Players } from '../Pages/Players';
import { LoginPage } from '../Pages/Auth';
import { SavedTrades } from '../Pages/SavedTrades';
import axios from 'axios';
import { apiServerUrl } from '../config';
import { PrivateRoute } from '../_components';
import { PlayerCard } from '../Components/PlayerCard';
import { ExpandedCalendar } from '../Components/BigCalendar';
import { authHeader, requestOptions } from '../_helpers';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom';

const fakeAuth = {
  isAuthenticated: false,
  authenticate(cb) {
    this.isAuthenticated = true;
    setTimeout(cb, 100); // fake async
  },
  signout(cb) {
    this.isAuthenticated = false;
    setTimeout(cb, 100);
  }
};

export const AppContext = React.createContext();

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      number: [10, 12, 13]
    };
  }

  componentDidMount() {
    let currentComponent = this;
    axios
      .get(apiServerUrl + '/teams', requestOptions())
      .then(function(response) {
        ////console.log(response);
        if (response.data) {
          currentComponent.setState({
            number: response.data
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    return (
      <div>
        <AppContext.Provider value={this.state}>
          <Switch>
            <PrivateRoute exact path="/" component={Dashboard} />
            <PrivateRoute exact path="/team" component={TeamManagement} />
            <PrivateRoute exact path="/cap" component={CapManagement} />
            <PrivateRoute exact path="/trade" component={Trade} />
            <PrivateRoute exact path="/contract" component={Contract} />
            <PrivateRoute exact path="/research" component={Research} />
            <PrivateRoute exact path="/wizard" component={Wizard} />
            <PrivateRoute path="/draft" component={Draft} />
            <PrivateRoute exact path="/account" component={Account} />
            <PrivateRoute exact path="/login" component={Login} />
            <PrivateRoute exact path="/depth" component={BigDepthChart} />
            <PrivateRoute exact path="/managers" component={Managers} />
            <PrivateRoute exact path="/players" component={Players} />
            <PrivateRoute exact path="/video" component={Video} />
            <PrivateRoute exact path="/add_user" component={AddUser} />
            <PrivateRoute exact path="/calendar" component={ExpandedCalendar} />
            <PrivateRoute exact path="/prop" component={SavedTrades} />
            <Route exact path="/auth" component={LoginPage} />
          </Switch>
        </AppContext.Provider>
      </div>
    );
  }
}

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);

    this.state = {
      username: '',
      password: '',
      redirectToReferrer: false,
      error: ''
    };
  }

  handleUsernameChange(event) {
    this.setState({ username: event.target.value });
  }
  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  handleSubmit(event) {
    ////console.log('A name was submitted: ' + this.state.username + ":" + this.state.password);
    event.preventDefault();
    if (
      (this.state.username == 'abc' && this.state.password == '123') ||
      (this.state.username == 'andrew' && this.state.password == 'password') ||
      (this.state.username == 'blawton9@me.com' &&
        this.state.password == 'hockeydatascience') ||
      (this.state.username == 'jwilson' && this.state.password == 'Babcock')
    ) {
      fakeAuth.authenticate(() => {
        this.setState({
          redirectToReferrer: true,
          error: ''
        });
      });
    } else {
      this.setState({ error: 'Incorrect Username/Password' });
    }
  }

  login = data => {
    fakeAuth.authenticate(() => {
      this.setState({ redirectToReferrer: true });
    });
  };

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } };
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }

    return (
      <div>
        <h2
          style={{
            marginLeft: '100px',
            color: 'white',
            fontWeight: '600',
            letterSpacing: '2.2px',
            display: 'inline-block',
            padding: '0em'
          }}
        >
          HOCKEY DATA SCIENCE CENTER
        </h2>

        <form
          onSubmit={this.handleSubmit}
          style={{
            marginLeft: '135px',
            padding: '100px 100px 100px 100px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#1a3d56',
            maxWidth: '400px',
            color: 'white',
            fontSize: '18px'
          }}
        >
          <label style={{ flex: 1 }}>
            Username:
            <input
              type="text"
              value={this.state.username}
              onChange={this.handleUsernameChange}
            />
          </label>
          <label style={{ flex: 1 }}>
            Password:
            <input
              type="password"
              value={this.state.password}
              onChange={this.handlePasswordChange}
            />
          </label>
          <input
            style={{ maxWidth: '100px', height: '50px' }}
            type="submit"
            value="Submit"
          />
          {this.state.error && (
            <h5 style={{ color: 'red' }}> {this.state.error} </h5>
          )}
        </form>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Pages/App.js